import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroVideo from "../HeroVideo/heroVideo";
import HomeSolutions from "../AboutSolutions/HomeSolutions";
import HomeProjects from "../HomeProjects/HomeProjects";
import Team from "../Team/Team";
import HomeCTA from "../HomeCTA/HomeCTA";
import ScrollStack from "../ScrollStack/ScrollStack";
import ClientsSection from "../ClientsSection/ClientsSection";
const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if we came from another page with a 'scrollTo' instruction
    if (location.state && location.state.scrollTo) {
      const targetId = location.state.scrollTo;
      
      // We use a 150ms timeout to give the Hero and other sections time to load
      const timer = setTimeout(() => {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          const offset = 100; // Adjust based on your Navbar height
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
          
          // Clear the state so it doesn't scroll again if you refresh the page
          window.history.replaceState({}, document.title);
        }
      }, 150); 

      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <main>
      <ScrollStack>
        <div id="home"><HeroVideo /></div>
        <HomeSolutions />
       
      </ScrollStack>
       <HomeProjects />
       <Team />
       <ClientsSection />
       <HomeCTA />
    </main>
  );
};

export default Home;